import * as Sentry from '@sentry/nextjs';
import { Integrations } from '@sentry/tracing';
import { mockAzarJs } from './mockAzarJs';

export const initMockAzarJs = (initMockProduct?: boolean) => {
  if (!window.AzarJs) {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production') {
      window.AzarJs = mockAzarJs;
      if (initMockProduct) {
        setTimeout(() => {
          // window.productPriceInfoListUpdated();
        }, 1000);
      }
    } else {
      Sentry.addBreadcrumb({
        category: 'AzarJs',
        level: "error",
        message: 'no azar js',
      });
      Sentry.captureMessage('no azar js');
    }
  }
};
